// extracted by mini-css-extract-plugin
export default {"delButton":"TrainingList_delButton__3dc6l","svgDel":"TrainingList_svgDel__Lr9nn","bookName":"TrainingList_bookName__d1kzT","bookNameMob":"TrainingList_bookNameMob__bJRht"};